import { render, staticRenderFns } from "./PaymentTypeNew.vue?vue&type=template&id=129f76cf&"
import script from "./PaymentTypeNew.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports